var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { runInAction } from "mobx";
import { Fragment } from "react";
import { Button, Column, Pre, Row } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { ScrollView } from "react-vscrollview";
import { store } from "Store";
import { MeID } from "Store/firebase/users";
import { CharacterDetailsUI, ShowAddCharacterDialog } from "UI/Write/CharacterDetailsUI";
import { Observer, PageContainer } from "vwebapp-framework";
import { GetCharacters, GetSelectedCharacter } from "../../Store/firebase/characters";
import { ShowSignInPopup } from "../@Shared/NavBar/UserPanel";
let CharactersUI = class CharactersUI extends BaseComponentPlus({}, {}) {
    render() {
        const { bookID } = this.props;
        const characters = GetCharacters(bookID);
        const selectedCharacter = GetSelectedCharacter(bookID);
        const { screenshotMode } = store.main.write;
        if (bookID == null)
            return React.createElement("div", null, "Please select a book.");
        const characters_ordered = characters.OrderBy(a => a.level);
        const userID = MeID();
        return (React.createElement(PageContainer, { preset: "full", innerStyle: { flexDirection: "row" } },
            React.createElement(Column, { className: "clickThrough", style: { width: 200, height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
                React.createElement(Row, { style: { height: 40, padding: 10 } },
                    React.createElement(Pre, null, "Characters"),
                    React.createElement(Button, { text: "+", ml: "auto", onClick: () => {
                            if (userID == null)
                                return ShowSignInPopup();
                            ShowAddCharacterDialog(userID, bookID);
                        } })),
                React.createElement(ScrollView, null, characters_ordered.map((char, index) => {
                    const differentLevelThanLastChar = index == 0 || characters_ordered[index - 1].level != char.level;
                    const text = char.name + (screenshotMode || char.note == null || char.note.trim().length == 0 ? "" : ` (${char.note})`);
                    return (React.createElement(Fragment, { key: char._key },
                        differentLevelThanLastChar
                            && React.createElement(Row, null,
                                "Level: ",
                                char.level),
                        React.createElement(Row, null,
                            React.createElement(Button, { mt: 5, text: text, style: { width: "100%" }, onClick: () => {
                                    runInAction("CharactersUI.select", () => store.main.write.selectedCharacter = char._key);
                                } }))));
                }))),
            React.createElement(Column, { ml: 10, style: { flex: 1, height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
                React.createElement(Column, { sel: true, style: { flexShrink: 0, background: "rgba(0,0,0,.7)", borderRadius: 10, padding: 10, alignItems: "flex-start", cursor: "auto" } }, selectedCharacter && React.createElement(CharacterDetailsUI, { baseData: selectedCharacter })))));
    }
};
CharactersUI = __decorate([
    Observer
], CharactersUI);
export { CharactersUI };
